
import '../footer/about.css';
import './Ajutor.css';
import { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faHeadset,
  faEnvelope,
  faQuestionCircle,
  faComments,
  faCheckCircle,
  faClock,
  faPhone
} from "@fortawesome/free-solid-svg-icons";

const Ajutor = () => {
  const [formData, setFormData] = useState({
    nume: '',
    email: '',
    message: ''
  });
  const [submitStatus, setSubmitStatus] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus('sending');
    
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${apiUrl}/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          nume: formData.nume,
          email: formData.email,
          message: formData.message
        })
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ nume: '', email: '', message: '' });
        
        // Resetam mesajul de succes dupa 5 secunde
        setTimeout(() => setSubmitStatus(''), 5000);
      } else {
        setSubmitStatus('error');
        setTimeout(() => setSubmitStatus(''), 5000);
      }
    } catch (error) {
      console.error('Eroare trimitere mesaj:', error);
      setSubmitStatus('error');
      setTimeout(() => setSubmitStatus(''), 5000);
    }
  };

  return (
    <div className="general-container-footer-info-ab">
      <div className="info-footer-container-ab">
        
     

        <div className='tittle-ab-top'>
          <h4>Contact</h4>
        </div>

   

        {/* Formular de contact */}
        <section className='section-about-2'>
          <div className='part-text-about ajutor-full-width'>
            <h4>
              <FontAwesomeIcon icon={faEnvelope} className='ajutor-title-icon' />
              Trimite-ne un mesaj
            </h4>
            
            {submitStatus === 'success' && (
              <div className='ajutor-success-box'>
                <FontAwesomeIcon icon={faCheckCircle} className='ajutor-success-icon' />
                <div>
                  <strong>Mesaj trimis cu succes!</strong>
                  <p className='ajutor-success-text'>Iti vom raspunde in maximum 48 de ore lucratoare.</p>
                </div>
              </div>
            )}

            {submitStatus === 'error' && (
              <div className='ajutor-success-box' style={{ borderColor: '#f44336', backgroundColor: '#fdecea' }}>
                <div>
                  <strong style={{ color: '#f44336' }}>Eroare la trimiterea mesajului.</strong>
                  <p className='ajutor-success-text'>Te rugam sa incerci din nou mai tarziu sau sa ne scrii direct la contact@contalearn.ro.</p>
                </div>
              </div>
            )}

            <form onSubmit={handleSubmit} className='ajutor-form'>
              <div className='ajutor-form-group'>
                <label htmlFor="nume" className='ajutor-label'>
                  Nume si prenume *
                </label>
                <input
                  type="text"
                  id="nume"
                  name="nume"
                  value={formData.nume}
                  onChange={handleChange}
                  placeholder="Ex: Ion Popescu"
                  required
                  className='ajutor-input'
                />
              </div>

              <div className='ajutor-form-group'>
                <label htmlFor="email" className='ajutor-label'>
                  Adresa de email *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="exemplu@email.ro"
                  required
                  className='ajutor-input'
                />
              </div>

              <div className='ajutor-form-group'>
                <label htmlFor="message" className='ajutor-label'>
                  Mesajul tau *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Descrie problema sau intrebarea ta cat mai detaliat..."
                  required
                  rows="6"
                  className='ajutor-input ajutor-textarea'
                />
              </div>

              <button
                type="submit"
                disabled={submitStatus === 'sending'}
                className={`ajutor-submit-btn ${submitStatus === 'sending' ? 'ajutor-submit-btn-sending' : ''}`}
              >
                <FontAwesomeIcon icon={faEnvelope} />
                {submitStatus === 'sending' ? 'Se trimite...' : 'Trimite mesajul'}
              </button>

              <p className='ajutor-required-text'>
                * Campuri obligatorii
              </p>
            </form>
          </div>
        </section>





      
      </div>
    </div>
  );
};

export default Ajutor;
